"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormTags(_a) {
    var video = _a.video, changed = _a.changed, setChanged = _a.setChanged, _b = _a.user, user = _b === void 0 ? {} : _b;
    var _c = ra_fetch_1.useApi('backend')
        .index('tags', { 'video_id': video.id, owner: 0 }), tags = _c[0], setTags = _c[1], params = _c[2], setParams = _c[3];
    react_1.useEffect(function () {
        if (changed) {
            setParams(__assign({}, params));
            setChanged(false);
        }
    }, [changed]);
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-videos-form-status' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'storybook-videos-form-status-title' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Video tags")),
            react_1.default.createElement(storybook_1.Texts.Small, { className: 'mt-4 mb-4' }, "Deze video verschijnt op de kanalen waar een tag voor bestaat."),
            react_1.default.createElement(storybook_1.Videos.TagList, { tags: tags.data, setTags: setTags }),
            user.role === 'coach' && react_1.default.createElement(storybook_1.Videos.FormTag, { video: video, tags: tags.data, setTags: setTags })));
}
exports.default = FormTags;
